import {
  Menu,
  MenuButton,
  Button,
  MenuList,
  MenuItem,
  Divider,
} from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles/settings-list.module.scss';

type Languages = 'zh' | 'en';

const AVAILABLE_LANGUAGES: Languages[] = ['zh', 'en'];

export const SettingsList: React.FC = ({}) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.language}>
        <div className={styles.itemText}>{t('language')}</div>

        <Menu matchWidth={true}>
          <MenuButton
            className={styles.settingsDropdownBtn}
            as={Button}
            // rightIcon={<ChevronDownIcon className={styles.settingsDownicon} />}
          >
            {t(i18n.language)}
          </MenuButton>
          <MenuList>
            {AVAILABLE_LANGUAGES.map((language, index) => (
              <MenuItem
                minH="48px"
                key={index}
                className={styles.settingsItem}
                onClick={() => {
                  i18n.changeLanguage(language);
                }}
              >
                {t(language)}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </div>
      <Divider margin="1em 0" />
    </div>
  );
};
